import Alpine from "alpinejs";
import collapse from '@alpinejs/collapse'
import resize from '@alpinejs/resize'
import focus from '@alpinejs/focus'
import EmblaCarousel from 'embla-carousel';
import Autoplay from 'embla-carousel-autoplay'
import Fade from 'embla-carousel-fade';

// Embla Carousel.
window.EmblaCarousel = EmblaCarousel;
window.Fade = Fade;
window.Autoplay = Autoplay;

// Alpine.js
window.Alpine = Alpine;
Alpine.plugin(collapse);
Alpine.plugin(resize);
Alpine.plugin(focus)
Alpine.start();

// HTMX.
window.htmx = require("htmx.org");

/*
  Animation for Statistics Block.
 */
function easeOut(x, power) {
    return 1 - Math.pow(1 - x, power);
}

function animateNumber(el, start, end, duration) {
    let startTimestamp = null;
    const step = (timestamp) => {
        if (!startTimestamp) {
            startTimestamp = timestamp;
        }
        const progress = Math.min(
            easeOut((timestamp - startTimestamp) / duration, 3),
            1,
        );
        el.innerHTML = Math.floor(
            progress * (end - start) + start,
        ).toLocaleString();
        if (progress < 1) {
            window.requestAnimationFrame(step);
        }
    };
    window.requestAnimationFrame(step);
}

window.easeOut = easeOut;
window.animateNumber = animateNumber;

